import UIFetchService from '../Service/UIFetchService';
import { isEmpty, isNotEmpty } from '../Service/Utils';

import moment from 'moment';
import React from 'react';
import { Skeleton } from 'antd';


class RealTimeLogsView extends React.Component {

    constructor() {
        super();
        this.state = {
            destUrl: '',
            innerHeight: 1000
        };
    }

    async componentDidMount() {
        let name = '';
        if (window.location.href.endsWith('logs_test')) {
            name = 'logs-test';
        } else if (window.location.href.endsWith('logs_prod')) {
            name = 'logs-product';
        }
        const resp = await UIFetchService.get(`/api/v1/logs_view/sign_in/${name}`);
        this.setState({ destUrl: resp.url });

        window.onresize = () => {
            this.setState({ innerHeight: document.body.clientHeight - 120 });
        };
        window.onresize();
    }

    componentWillUnmount() {
        delete window.onresize;
    }

    render() {
        return <>
        {isEmpty(this.state.destUrl) && <Skeleton style={{height: this.state.innerHeight}} active />}
        {isNotEmpty(this.state.destUrl) && <iframe
                src={this.state.destUrl}
                width="100%"
                height={this.state.innerHeight}
                frameBorder={0}
                style={{ border: "0px" }}
                onLoad={e => {
                    const url = e.target.src;
                    if (url.startsWith('https://signin.aliyun.com/federation?Action=Login')) {
                        const now = moment().add(3, 'hours').format('YYYY-MM-DD HH:mm:ss');
                        localStorage.setItem('realTime.sls.expries', now);
                    }
                }}
            >
            </iframe>}
        </>;
    }
};

export default RealTimeLogsView;